export enum API_ERRORS {
  MISSING_TEMPLATE = "404",
  BAD_CREDENTIALS = "does not match user current password",
  USED_COLOR_SCHEME = "can't delete palette",
  TEST_CARD_ERROR = "does not match template regions",
  NOT_MATCHING_REGIONS = "user regions don't match template regions",
}
